import React from 'react';
import IndexPage from './pages';
import './i18n';

function App() {
  return (
    <div className="App">
      <IndexPage />
    </div>
  );
}

export default App;
